import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e065034e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e065034e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e065034e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e065034e')) {
      api.createRecord('e065034e', component.options)
    } else {
      api.reload('e065034e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e065034e&scoped=true&", function () {
      api.rerender('e065034e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4xZMY1aiN6FwV/JS/comp/SearchFilterTokens.vue"
export default component.exports